import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const EMOTORAD__CUSTOMERS__PHONE_NUMBER_COLUMN_ID = "dd1c3cfb-d8e2-469d-a240-c98319f93065" as Uuid;

export const EMOTORAD__CUSTOMERS__CUSTOMER_NAME_COLUMN_ID = "88bb26fa-95db-46a7-a8ec-d113c5ffbd51" as Uuid;

export const EMOTORAD__CUSTOMERS__CUSTOMER_STATUS_COLUMN_ID = "c324d2ea-bae4-4c07-a5f2-1942afa11fc5" as Uuid;

export const EMOTORAD__CUSTOMERS__CUSTOMER_PLATFORM_COLUMN_ID = "cac39708-4a71-4a3d-8089-f2586e0fd314" as Uuid;

export const EMOTORAD__CUSTOMERS__SOURCE_CHANNEL_COLUMN_ID = "327b2cdc-e18a-4ff7-9171-8b5e243e9e66" as Uuid;

export const EMOTORAD__CUSTOMERS__ASSIGNED_DEALERS_COLUMN_ID = "8a886cf5-7a8e-47eb-9cc7-35846b47a39f" as Uuid;

export const EMOTORAD__CUSTOMERS__EVENT_CONTAINER_COUNT_COLUMN_ID = "2e282b49-5987-444d-8d4c-f609780e8876" as Uuid;

export const EMOTORAD__CUSTOMERS__LEADS_COUNT_COLUMN_ID = "5c696816-88cb-49ad-aa37-842125c6d199" as Uuid;

export const EMOTORAD__CUSTOMERS__LIVE_EVENT_CONTAINER_COUNT_COLUMN_ID = "bbc6ec9f-dd26-4620-8c3f-ed918ac4a758" as Uuid;

export const EMOTORAD__CUSTOMERS__CHURNED_EVENT_CONTAINER_COUNT_COLUMN_ID = "6a36d12d-2814-429d-b9c8-eaae03605bf3" as Uuid;

export const EMOTORAD__CUSTOMERS__CONVERTED_EVENT_CONTAINER_COUNT_COLUMN_ID = "2c33405f-c040-42c8-a167-36f2acb38a88" as Uuid;

export const EMOTORAD__CUSTOMERS__DUPLICATE_EVENT_CONTAINER_COUNT_COLUMN_ID = "96baeedd-d0aa-4764-a27d-1f912546e3bc" as Uuid;

export const EMOTORAD__CUSTOMERS__ARCHIVE_EVENT_CONTAINER_COUNT_COLUMN_ID = "e144fd53-e11a-4dfa-9df3-cb1a53497eaf" as Uuid;

export const EMOTORAD__CUSTOMERS__CALLS_COUNT_COLUMN_ID = "64b595ca-d417-44ce-acd9-4480a0c72c81" as Uuid;

export const EMOTORAD__CUSTOMERS__WALKINS_COUNT_COLUMN_ID = "9859acda-6813-4a36-8465-31e9392eabbf" as Uuid;

export const EMOTORAD__CUSTOMERS__TEST_RIDES_COUNT_COLUMN_ID = "30dc2ab5-6308-450d-8b4f-b0e04cc8bb52" as Uuid;

export const EMOTORAD__CUSTOMERS__SALES_COUNT_COLUMN_ID = "24d1d335-9238-42c1-a1d5-ea57def153f7" as Uuid;

export const EMOTORAD__CUSTOMERS__LAST_CUSTOMER_ACTIVITY_COLUMN_ID = "494971e6-8125-4bc5-892c-baa7f2d27d3f" as Uuid;

export const EMOTORAD__CUSTOMERS__LAST_EVENT_CONTAINER_CREATED_ON_COLUMN_ID = "838cbe5f-0779-429c-9d18-1761ecb1f257" as Uuid;

export const EMOTORAD__CUSTOMERS__LAST_EVENT_CONTAINER_CREATED_BY_COLUMN_ID = "d473ef5d-41e5-48ee-b32c-aa16ffc50d4a" as Uuid;

export enum EmotoradCustomerStatusEnum {
    ACTIVE = "48972e9e-7cd9-494e-8454-8f519cf9d586",
    INACTIVE = "c11943b3-2972-40d1-a0dd-1b3da43f8a9d",
}

/** Customer (account) module — contact number + name per emotoradSetup.csv Customers (Accounts). */
/** Per-account rollups — emotoradSetup.csv §1 (Customers). */

/** Customer (account) status — option IDs for {@link EMOTORAD__CUSTOMERS__CUSTOMER_STATUS_COLUMN_ID}. */
export const emotoradCustomerStatuses: Record<
    EmotoradCustomerStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradCustomerStatusEnum.ACTIVE]: {
        id: EmotoradCustomerStatusEnum.ACTIVE as Uuid,
        displayName: "Active",
    },
    [EmotoradCustomerStatusEnum.INACTIVE]: {
        id: EmotoradCustomerStatusEnum.INACTIVE as Uuid,
        displayName: "Inactive",
    },
};

export const getEmotoradCustomerStatuses = () => Object.values(emotoradCustomerStatuses);
